import React, { useState, useEffect } from "react";
import styled from "styled-components";
import moment from "moment";

// constants
import {
  calculateTotalPaid,
  convertCurrency,
  convertImageToBase64,
  numberFormat,
} from "../../helper";
import { S3_URL } from "../../const";
import { useTranslation } from "react-i18next";

export default function BillforSale80({
  Location,
  ordergroup,
  shopData,
  prepareRate,
}) {
  const [shop, setShop] = useState();
  const [isBillNumber, setIsBillNumber] = useState("bill_1");
  const [base64Image, setBase64Image] = useState("");
  const [ordersNow, sertOrderNow] = useState([]);
  const { t } = useTranslation();

  const bill = Location?.state?.state ?? ordergroup ?? {};
  const sumPrice = bill?.sumPrice ?? 0;
  const currency = bill?.currency;
  const totals = calculateTotalPaid(sumPrice, currency, prepareRate);
  const receivedMoney = bill?.receivedMoney ?? 0;
  const change =
    bill?.change ??
    parseFloat(receivedMoney || 0) - parseFloat(totals?.totalKip || 0);

  // useEffect Hooks
  useEffect(() => {
    if (shopData) {
      setShop(shopData);

      const { isBillNumber, isLessStock, image } = shopData;
      setIsBillNumber(isBillNumber);

      const _getImage = S3_URL + shopData?.image;

      convertImageToBase64(_getImage).then((base64) => {
        setBase64Image(base64);
      });
    } else {
      let localDatas = JSON.parse(localStorage.getItem("SHOP_DATA"));
      setShop(localDatas);

      const { isBillNumber, isLessStock, image } = localDatas;
      setIsBillNumber(isBillNumber);

      const _getImage = S3_URL + localDatas?.image;

      convertImageToBase64(_getImage).then((base64) => {
        setBase64Image(base64);
      });
    }
  }, [shopData]);

  // useEffect Hooks
  useEffect(() => {
    sertOrderNow(ordergroup?.orders || ordergroup);
  }, [ordergroup]);

  return (
    <div style={{ padding: "0 15px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        {base64Image && (
          <img
            src={base64Image}
            alt={shop?.name}
            style={{ maxWidth: 104, maxHeight: 104 }}
          />
        )}

        <b style={{ fontSize: 20, marginTop: 5 }}>{shop?.name}</b>
        <div style={{ width: "100%", textAlign: "center" }}>
          <p style={{ fontSize: 12 }}>
            {shop?.address?.village +
              ", " +
              shop?.address?.district +
              ", " +
              shop?.address?.province}
          </p>
          <p style={{ marginTop: -3, fontSize: 12 }}>{shop?.phone ?? ""}</p>
        </div>
      </div>
      <div style={{ textAlign: "center", padding: 5 }}>
        <h3 style={{ fontSize: 18, fontWeight: "bold" }}>
          {isBillNumber === "bill_3"
            ? t("invoice_titleV2")
            : t("invoice_title")}
        </h3>
      </div>
      <div style={{ textAlign: "left", fontSize: 12 }}>
        {t("number_no")} : {bill?.code}{" "}
      </div>

      <div style={{ textAlign: "left", fontSize: 12 }}>
        {t("createdBy")} : {bill?.staff} {bill?.staffLastname}{" "}
      </div>
      <div style={{ textAlign: "left", fontSize: 12 }}>
        {t("customer_name")}: {bill?.customerName ?? "......................"}{" "}
        {bill?.customerLastName ?? "......................"}{" "}
      </div>
      <div style={{ textAlign: "left", fontSize: 12 }}>
        {t("phone_number")}: {bill?.phone ?? "......................"}
      </div>
      <div style={{ textAlign: "left", fontSize: 12 }}>
        ຂໍ້ມູນປາຍທາງ: {bill?.addressCf ?? "......................"}
      </div>
      <div
        style={{
          textAlign: "left",
          fontSize: 12,
          borderBottom: "1px solid black",
        }}
      >
        {t("day_month_year")} :{" "}
        {moment(bill?.checkBillDate ?? bill?.createdAt).format(
          "DD/MM/YYYY HH:mm:ss",
        )}
      </div>
      <div style={{ height: 5 }} />
      <Order>
        <>
          {ordersNow
            ?.slice()
            .sort((a, b) => parseInt(a.sortId) - parseInt(b.sortId))
            .map((order, index) => (
              <div
                style={{
                  fontSize: 1,
                  lineHeight: 1.2,
                }}
                key={index}
              >
                <div
                  style={{ textAlign: "left", fontSize: 14, display: "flex" }}
                >
                  <div style={{ fontWeight: "bold", marginRight: 10 }}>
                    {index + 1}
                  </div>
                  <div>
                    {order?.productName}
                    {order?.survival &&
                      shopData?.id === "63ec6d38c617221e6ccf5edc" && (
                        <span style={{ color: "#a3a3a3ff", fontSize: 11 }}>
                          ເລກລ໊ອຕ: {order?.survival}
                        </span>
                      )}
                  </div>
                </div>
                <div
                  style={{
                    textAlign: "left",
                    paddingLeft: 18,
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <p style={{ fontWeight: "bold", fontSize: 11 }}>
                    {(() => {
                      const basePrice = parseInt(order?.price || 0, 10);
                      const optionPrice = (order?.options || []).reduce(
                        (acc, item) => acc + parseInt(item?.price || 0, 10),
                        0,
                      );
                      return (
                        <>
                          {order?.amount}{" "}
                          {order?.stock?.unit ??
                            order?.stock?.unitId?.name ??
                            ""}{" "}
                          X {numberFormat(basePrice + optionPrice)}{" "}
                          {convertCurrency(order?.currency)}{" "}
                          {order?.amountFree ? (
                            <>ແຖມ: {order?.amountFree ?? ""}</>
                          ) : (
                            ""
                          )}
                        </>
                      );
                    })()}
                  </p>
                  <p style={{ fontWeight: "bold", fontSize: 11 }}>
                    {" "}
                    {numberFormat(
                      order?.totalPrice ??
                        parseFloat(order?.price || 0) *
                          parseFloat(order?.amount || 0),
                    )}{" "}
                    {convertCurrency(order?.currency)}
                  </p>
                </div>

                {(order?.children || []).map((child, childIndex) => (
                  <div
                    key={`${index}-${childIndex}`}
                    style={{
                      textAlign: "left",
                      paddingLeft: 30,
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: 11,
                      fontWeight: "bold",
                      marginTop: 2,
                    }}
                  >
                    <span>
                      {String(child?.tag || child?.saleTag || "").toUpperCase() === "FREE" ? "ແຖມ" : `${index + 1}.${childIndex + 1}.`} {child?.productName} (
                      {child?.amount ?? child?.volume})
                    </span>
                    <span>{numberFormat(child?.price ?? 0)}</span>
                  </div>
                ))}
              </div>
            ))}

          <div
            style={{
              display: "flex",
              marginTop: "-.2em",
              justifyContent: "space-between",
              borderTop: "1px solid black",
              margin: "12px 0",
            }}
          >
            <p style={{ fontWeight: "bold", fontSize: 14 }}>
              {t("totals_name")} :
            </p>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                fontSize: 14,
                fontWeight: "bold",
              }}
            >
              <span>{numberFormat(bill?.totalPrice ?? 0)} ₭</span>
              <span>{numberFormat(bill?.sumPriceBaht ?? 0)} ฿</span>
              <span>{numberFormat(bill?.sumPriceUsd ?? 0)} $</span>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
              borderBottom: "1px solid black",
            }}
          >
            {(bill?.cash ?? 0) > 0 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  fontSize: 14,
                  fontWeight: "bold",
                }}
              >
                <span>ເງິນສົດ:</span>
                <span>
                  {numberFormat(bill?.cash ?? 0)} {bill?.currency}
                </span>
              </div>
            )}

            {(bill?.transfer ?? 0) > 0 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  fontSize: 14,
                  fontWeight: "bold",
                }}
              >
                <span>ເງິນໂອນ:</span>
                <span>
                  {numberFormat(bill?.transfer ?? 0)} {bill?.currency}
                </span>
              </div>
            )}

            {(bill?.debt ?? 0) > 0 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  fontSize: 14,
                  fontWeight: "bold",
                }}
              >
                <span>ຕີດຫນີ້:</span>
                <span>
                  {numberFormat(bill?.debt ?? 0)} {bill?.currency}
                </span>
              </div>
            )}

            {isBillNumber === "bill_2" ? (
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <span>ລວມເປັນບາດ :</span>
                  <b style={{ fontSize: 18 }}>
                    {numberFormat(totals?.totalBaht ?? 0)} ບາດ
                  </b>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <span>ລວມເປັນໂດລາ :</span>
                  <b style={{ fontSize: 18 }}>
                    {numberFormat(totals?.totalUsd ?? 0)} ໂດລາ
                  </b>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    fontSize: 20,
                    fontWeight: "bold",
                  }}
                >
                  <span>ລວມເປັນກີບ :</span>
                  <span>{numberFormat(totals?.totalKip ?? 0)} ກີບ</span>
                </div>
              </>
            ) : (
              <>
                {((bill?.discount ?? 0) > 0 ||
                  (bill?.discountManual ?? 0) > 0) && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                      fontSize: 14,
                      fontWeight: "bold",
                      marginTop: 5,
                    }}
                  >
                    <span>ສ່ວນຫລຸດ:</span>
                    <span>
                      {(() => {
                        const manual = bill?.discountManual ?? 0;
                        const base = bill?.discount ?? 0;
                        if (manual > 0) {
                          const unit = bill?.discountType ? "₭" : "%";
                          return `${numberFormat(manual)} ${unit}`;
                        }
                        return `${numberFormat(base)} %`;
                      })()}
                    </span>
                  </div>
                )}

                {bill?.taxes?.taxStatus && (
                  <>
                    <div style={{ display: "flex", justifyContent: "space-between", marginTop: 5, fontSize: 14, fontWeight: "bold" }}>
                      <span>ລາຄາບໍ່ລວມອາກອນ</span>
                      <span>{numberFormat(bill?.taxes?.priceBeforeTax ?? 0)} ₭</span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", marginTop: 5, fontSize: 14, fontWeight: "bold" }}>
                      <span>
                        ອາກອນມູນຄ່າເພີ່ມ {bill?.taxes?.tax ?? 0}
                        {bill?.taxes?.taxType === "PERCENT" ? "%" : "₭"}
                      </span>
                      <span>{numberFormat(bill?.taxes?.taxAmount ?? 0)} ₭</span>
                    </div>
                  </>
                )}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    fontSize: 16,
                    fontWeight: "bold",
                    color: "green",
                    marginTop: 5,
                  }}
                >
                  <span>ຍອດເງິນລວມທັງໝົດ:</span>
                  <span>{numberFormat(bill?.sumPrice || 0)} ກີບ</span>
                </div>
              </>
            )}
          </div>
        </>
      </Order>

      <p
        style={{
          fontSize: 12,
          marginTop: 6,
          textAlign: "center",
          width: "100%",
        }}
      >
        {shopData?.descriptionPOSBill ??
          shop?.descriptionPOSBill ??
          "ຂອບໃຈລູກຄ້າທີ່ມາໃຊ້ບໍລິການ"}
      </p>
      <p style={{ fontSize: 12 }}>
        ເງິນທີ່ໄດ້ຮັບມາ {numberFormat(receivedMoney ?? 0)} ກີບ, ຄ່າເຄື່ອງ{" "}
        {numberFormat(totals?.totalKip ?? 0)} ກີບ, ເງິນທີ່ຕ້ອງຖອນກັບຄືນ{" "}
        {numberFormat(change <= 0 ? 0 : change)} ກີບ
      </p>
    </div>
  );
}

const Order = styled.div`
  display: flex;
  flex-direction: column;
`;
